import React from 'react';
import { Switch } from '@mui/material';

const styles = require('./styles.pcss');
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
type Props = {
  enabled: boolean;
  handleClick?: any;
  id?: any;
  hasPermission: boolean;
};

class CustomizedSwitches extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  handleChange = (event: any, value: any) => {
    this.props.handleClick(event);
  };
  

  render() {
    return (
      <FormControlLabel
        control={
          <Switch
            disabled={this.props.hasPermission}
            color={'primary'}
            disableRipple
            checked={this.props.enabled}
            onChange={this.handleChange}
            value="checked"
            id={this.props.id}
          />
        }
        label=""
      />
    );
  }
}

export default CustomizedSwitches;
